export default "__VITE_ASSET__6f0d6ebe__"